import useWindowSize from '@/hooks/useWindowSize'

import StatusVisual from './StatusVisual'
import StatusText from './StatusText'
import StreamingDots from '../StreamingDots/StreamingDots'
import { resolveMessageSize, resolveStatusVisual } from './statusPresets'

import type { StatusMessageProps } from './types/StatusMessageTypes'

import './StatusMessage.scss'

const TRAILING_ELLIPSIS = /\s*(\.{3}|…)$/

// A row of the status: the visual (from the type or given) and the text
const StatusMessage = ({ type, visual, message, messageSize, state }: StatusMessageProps) => {
    const { isMobile } = useWindowSize()
    // While a step is running, its trailing "..." is shown as the animated dots
    const hasAnimatedDots = state === 'loading' && TRAILING_ELLIPSIS.test(message)
    const text = hasAnimatedDots ? message.replace(TRAILING_ELLIPSIS, '') : message
    const textSize = resolveMessageSize(type, isMobile, messageSize)

    return (
        <div className={`status-message${state ? ` status-message--${state}` : ''}`}>
            <StatusVisual visual={resolveStatusVisual(type, visual)} title={message} />
            {hasAnimatedDots ? (
                <span className="status-message__label">
                    <StatusText size={textSize}>{text}</StatusText>
                    <StreamingDots />
                </span>
            ) : (
                <StatusText size={textSize}>{message}</StatusText>
            )}
        </div>
    )
}

export default StatusMessage
